[
	null,
	"Galactic Centre",
	"Empyrean Straits",
	"Ryker's Hope",
	"Odin's Hold",
	"Norma Arm",
	"Arcadian Stream",
	"Izanami",
	"Inner Orion-Perseus Conflux",
	"Inner Scutum-Centaurus Arm",
	"Norma Expanse",
	"Trojan Belt",
	"The Veils",
	"Newton's Vault",
	"The Conduit",
	"Outer Orion-Perseus Conflux",
	"Orion-Cygnus Arm",
	"Temple",
	"Inner Orion Spur",
	"Hawking's Gap",
	"Dryman's Point",
	"Sagittarius-Carina Arm",
	"Mare Somnia",
	"Acheron",
	"Formorian Frontier",
	"Hieronymus Delta",
	"Outer Scutum-Centaurus Arm",
	"Outer Arm",
	"Aquila's Halo",
	"Errant Marches",
	"Perseus Arm",
	"Formidine Rift",
	"Vulcan Gate",
	"Elysian Shore",
	"Sanguineous Rim",
	"Outer Orion Spur",
	"Achilles's Altar",
	"Xibalba",
	"Lyra's Song",
	"Tenebrae",
	"The Abyss",
	"Kepler's Crest",
	"The Void"
]
